export default __webpack_public_path__ + "static/media/loja.1ce06318.jpeg";